module.exports = __webpack_public_path__ + "/build/web/images/custom-made-textiles@2x.8f943ba27e62debc90fdb1af96335b0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/custom-made-textiles@2x.jpg
// module id = 125
// module chunks = 13